<template>
  <div
    class="dwp-inline-flex dwp-justify-center dwp-rounded dwp-border dwp-border-gray-800 dwp-text-white dwp-bg-transparent dwp-text-center dwp-color-white dwp-px-2 dwp-py-1 dwp-border-rounded-sm dwp-cursor-pointer dwp-appearance-none"
    :class="{ 'dwp-bg-gray-700': active }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean,
  },
};
</script>